export const reports = {
    state: {
        status: 'idle',
        reports: null,
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        }
    },
    mutations: {
    },
    actions: {
    },
    getters: {
    }
}
